import LocaleContext from "components/i18n/LocaleContext";
import TextTooltip from "components/shared/TextTooltip";
import { palette } from "lib/miolo";
import { useContext } from "react";
import type { IRatingSummaryDistributionItem } from "types/graphqlTypes";

interface IRatingDistributionProps {
  distribution: IRatingSummaryDistributionItem[];
}

function RatingDistribution({ distribution }: IRatingDistributionProps) {
  const locale = useContext(LocaleContext);
  return (
    <div className="space-y-1">
      {[...distribution]
        .sort((a, b) => {
          return b.rating - a.rating;
        })
        .map(({ rating, totalRatings, percentOfTotal }) => {
          let tooltipContent = `${totalRatings} ${totalRatings === 1 ? "avaliação" : "avaliações"}`;
          if (locale === "USA") {
            tooltipContent = `${totalRatings} ${totalRatings === 1 ? "rating" : "ratings"}`;
          }

          return (
            <TextTooltip
              key={rating}
              id={`tooltips/RatingDistribution/${rating}`}
              placement="top"
              content={tooltipContent}
              style={{
                maxWidth: 260,
                textAlign: "center",
              }}
            >
              {({ accessibility, bind, ref }) => (
                <div>
                  <div className="flex items-center space-x-4" {...accessibility} {...bind}>
                    <span className="w-2 text-center font-aeonik text-sm font-bold text-gray-600">{rating}</span>

                    <div className="h-2 w-full rounded-xl bg-gray-100 xl:w-36" ref={ref}>
                      <div
                        style={{
                          width: `${Math.ceil(percentOfTotal * 100)}%`,
                          height: "100%",
                          backgroundColor: rating < 3 ? palette.mojo : palette.fuelYellow,
                          borderRadius: 4,
                        }}
                      />
                    </div>
                  </div>
                </div>
              )}
            </TextTooltip>
          );
        })}
    </div>
  );
}

export default RatingDistribution;
